import { Spinner } from "flowbite-react";

export default function Page() {
    return (
        <>
            <div className="flex flex-wrap gap-2 h-screen w-screen">
                <div className="text-center m-auto">
                    <Spinner size="xl" />
                </div>
            </div>

        </>
    )
}